import React from 'react';
import createReactContext from '../context';
var context = createReactContext({}); // eslint-disable-next-line

export var Provider = context.Provider;
export var consumer = function consumer(Origin) {
  return function (props) {
    return (
      /*#__PURE__*/
      React.createElement(context.Consumer, null, function (value) {
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, props, value))
        );
      })
    );
  };
};